export const mutations = {
    SHOW_ADVANCED_SEARCH(state, show) {
        state.showAdvancedSearch = show === undefined ? !state.showAdvancedSearch : show;
    },

    SET_VECTOR(state, vector) {
        state.parcelVector = vector;
    },

    GET_CADASTRAL_REAL_ESTATE(state, data) {
        state.cadastralRealEstate = data;
    }
};
